import * as forgotPasswordActionTypes from './constants'

/**
 *
 */
function getInitialState() {
	return {
		inProgress: false,
		errorCode: false,
		invalidEmail: false,
		emailSent: false,
	}
}

const forgotPasswordReducer = (state = getInitialState(), action) => {
	switch (action.type) {
		case forgotPasswordActionTypes.FORGOT_PASSWORD_REQUEST: {
			return {
				...state,
				inProgress: true,
				invalidEmail: false,
				errorCode: false,
				emailSent: false,
			}
		}
		case forgotPasswordActionTypes.FORGOT_PASSWORD_SUCCESS:
			return {
				...state,
				emailSent: true,
				invalidEmail: false,
				inProgress: false,
				errorCode: false,
			}
		case forgotPasswordActionTypes.FORGOT_PASSWORD_RESET:
			return getInitialState()
		case forgotPasswordActionTypes.FORGOT_PASSWORD_ERROR: {
			return {
				...state,
				errorCode: action.payload,
				inProgress: false,
				invalidEmail: false,
				emailSent: false,
			}
		}
		case forgotPasswordActionTypes.FORGOT_PASSWORD_INVALID_EMAIL: {
			return {
				...state,
				invalidEmail: true,
				inProgress: false,
				errorCode: false,
				emailSent: false,
			}
		}
		default: {
			return state
		}
	}
}

export default forgotPasswordReducer
